import axiosInstance from "./AxiosInstance";

export function getGrnListApi(params = {}) {
  const queryParams = new URLSearchParams(params);
  return axiosInstance.get(`api/grn?${queryParams.toString()}`);
}

export function grnImportApi(data) {
  return axiosInstance.post("api/import-grn", data);
}

export function getGrnApi(grnId) {
  return axiosInstance.get(`api/grn/${grnId}`);
}

export function creategrnApi(data) {
  return axiosInstance.post("api/grn", data);
}

export function addAssetInGrnApi(id,data) {
  return axiosInstance.post(`api/grn/${id}`, data);
}

export function updateGrnApi(data) {
  return axiosInstance.put("api/grn", data);
}

export function getGrnNumberApi() {
  return axiosInstance.get("api/get-grn-number");
}

export function getGrnAssetUnitListApi(grnId, params = {}) {
  const queryParams = new URLSearchParams(params);
  return axiosInstance.get(`api/grn-assets/${grnId}?${queryParams.toString()}`);
}
export function getGrnListExport(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/export-grn?${fparam}`, {
    responseType: "blob",
  });
}
